export enum SettingsTabs {
  SECURITY = 'security',
  API_KEYS = 'api_keys',
  USERS = 'users',
  SCIM_PROVISIONING = 'scim_provisioning'
}
